import { z } from 'zod';

export const BigdesMeasureSchema = z.object({
    id: z.string().optional(),
    measure_code: z.string().min(1),
    tier: z.number().int().min(1).max(3).nullable().optional(),
    title: z.string().min(1),
    description: z.string().nullable().optional(),
    audit_questions: z.array(z.string()).default([]),
    audit_methods: z.array(z.string()).default([]),
    parent_code: z.string().nullable().optional(),
    section_code: z.string().nullable().optional(),
    catalog_source: z.string().nullable().optional(),
    is_editable: z.boolean().default(false),
    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export const BigdesMeasureListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(20),
    limit: z.coerce.number().int().min(1).max(200).optional(),
    search: z.string().optional(),
    sortBy: z.string().optional(),
    sortOrder: z.enum(['asc', 'desc']).default('asc'),
});
